// @flow

import React from 'react';

import { base } from 'app/developer-v3/components/PartnerSupportForm/utils/tree';

import type { NodeDefinition } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';
import { type NodeOptions } from 'app/developer-v3/components/PartnerSupportForm/components/blocks/App/types';

import App from './App';

const app = (options: NodeOptions): NodeDefinition => {
  const node = base({
    id: 'app',
    isRequired: options.isRequired === true,
    children: {
      [options.child.id]: options.child,
    },
    hasData: data => {
      // `null` means they skipped
      return data || data === null;
    },
    getNextNode: () => {
      return options.child;
    },
    render: props => {
      return (
        <App
          {...props}
          developer={options.developer === true}
          label={options.label}
        />
      );
    },
    export: data => {
      return {
        id: node.id,
        data:
          data && data.name && data.id
            ? data.name + ' - App id: ' + data.id
            : data && data.id
            ? data.id
            : null,
        label: options.label,
      };
    },
  });

  return node;
};

export default app;
